<template>
  <div class="web-box-all">
    <ext-header></ext-header>

    <div class="web-home-main">
      <div class="web-order-state">
        <h2>
          <p>订单编号：{{order_info.erp_order_no!='' ? order_info.erp_order_no : order_info.order_no}} <b>({{order_info.ctime}})</b> </p>
          <a>{{header_title}}</a>
        </h2>
      </div>

      <div class="web-order-main">

        <div class="web-order-address">
            <h2>餐厅名称：{{order_info.store_name}}</h2>
            <ul>
                <li v-if="order_info.market_name">
                    <p>所属市场：{{order_info.market_name}}</p>
                </li>
                <li v-if="company_no=='MCD-CHN'">
                    <p>门店编号：{{order_info.store_no}}</p>
                </li>
                <li v-else>
                    <p>门店账号：{{order_info.store_no}}</p>
                </li>
                <li v-if="order_info.zoneNo">
                    <p>国际编码：{{order_info.zoneNo}}</p>
                </li>
                <li v-if="order_info.market_name">
                    <p>餐厅电话：{{order_info.store_phone}}</p>
                </li>
                <li v-if="order_info.store_phone">
                    <p>联系电话：{{order_info.store_phone}}</p>
                </li>
                <li v-if="order_info.store_address">
                    <p>餐厅地址：{{order_info.store_address}}</p>
                </li>
                <li v-if="order_info.pbs_add_store_address">
                    <p>要求发货地址：{{order_info.pbs_add_store_address}} （{{order_info.pbs_add_store_phone}}）</p>
                </li>
            </ul>
        </div>
        <div class="web-order-address-line"></div>

        <div class="web-order-info-title">
            <h2>订单备注</h2>
            <p>{{order_info.order_remark}}</p>
        </div>

        <div class="web-order-info-title" style="border:0px;">
            <h2>商品清单</h2>
        </div>

        <div class="web-order-goods-list-box">
          <div  class="web-order-goods-list-top">
            <ul>
              <li style="width:330px; padding-left:50px;">商品</li>
              <li style="width:230px; padding-left:50px;">商品编号</li>
              <li style="width:130px; padding-left:50px;">单价</li>
              <li style="width:130px; padding-left:50px;">数量</li>
              <li style="width:130px; padding-left:50px;">总价</li>
            </ul>
          </div>
        </div>

        <div class="web-order-goods-box">

            <div v-for="(vo,index) in goods_list" :key="index" class="web-cart-list-data">
                <div class="web-cart-list-checkbox">
                    <img @click="get_goods_show(vo.goods_no)" src="@/assets/goods_load.png" v-real-img="web_url+vo.goods_image">
                </div>
                <div class="web-cart-list-goods">
                    <p>{{vo.goods_name}}</p>
                    <a>{{vo.goods_no}}</a>
                </div>
                <div class="web-cart-list-props">
                  <p>{{vo.goods_no}}</p>
                </div>
                <div class="web-cart-list-price">
                  <p>￥{{vo.price}}</p>
                </div>
                <div class="web-cart-list-quantity">
                  <p>{{vo.qty}}</p>
                </div>
                <div class="web-cart-list-quantity">
                  <p>￥{{ (vo.price * vo.qty).toFixed(2) }}</p>
                </div>
            </div>

        </div>

      </div>

      <div class="web-order-footer">
        <ul style="margin-top:10px;">
            <li v-if="company_no=='MCD-CHN'">
                <p>发货方式：</p>
                <a v-if="order_info.delivery_way==2">有货先发</a>
                <a v-else>齐货发</a>
            </li>
            <li v-if="order_info.logistics_name">
                <p>配送方式：</p>
                <a>{{order_info.logistics_name}}</a>
            </li>
            <li v-if="order_info.logistics_no">
                <p>快递单号</p>
                <a>{{order_info.logistics_no}}</a>
            </li>
            <li>
                <p>商品合计：</p>
                <a>￥{{order_info.goods_money}}</a>
            </li>
            <li v-if="company_no=='MCD-CHN'">
                <p>优惠金额：</p>
                <a>-￥{{order_info.coupon_fee}}</a>
            </li>
            <li v-if="company_no=='MCD-CHN'">
                <p>抵扣金额：</p>
                <a>-￥{{order_info.deduction_fee}}</a>
            </li>
            <li v-if="company_no=='MCD-CHN'">
                <p>兑换积分：</p>
                <a>{{order_info.deduction_integral}}</a>
            </li>

            <li v-if="order_info.erp_pack_fee>0">
                <p>包装及运费(小定单)：</p>
                <a>{{order_info.erp_pack_fee}}</a>
            </li>
            <li v-if="order_info.erp_file_fee>0">
                <p>文件处理费：</p>
                <a>{{order_info.erp_file_fee}}</a>
            </li>
            <li v-if="order_info.erp_insurance_fee>0">
                <p>保险费：</p>
                <a>{{order_info.erp_insurance_fee}}</a>
            </li>
            <li v-if="order_info.erp_facility_fee>0">
                <p>不锈钢设备优惠：</p>
                <a>{{order_info.erp_facility_fee}}</a>
            </li>

        </ul>
        <ul class="money" style="margin-top:10px;">
            <li>
                <p>订单金额：</p>
                <a class="red">￥{{order_info.pay_money}}</a>
            </li>
            <li v-if="order_info.logistics_fee!='0.00'">
                <a><span class="select">运费：￥{{order_info.logistics_fee}}</span></a>
            </li>
        </ul>

        <h2 v-if="order_info.order_state==4 || order_info.order_state==5 || order_info.order_state==6">
            <a @click="get_logistics_info(order_info.order_no)" v-if="order_info.order_state==4 || order_info.order_state==5 || order_info.order_state==6">查看物流</a>
            <a @click="get_sales_return(order_info.order_no)" v-if="order_info.order_state==5 && order_info.return_state=='0' && company_no=='MCD-CHN'">申请退货</a>
            <a @click="get_sales_return(order_info.order_no)" v-if="order_info.order_state==6 && order_info.return_state=='0' && company_no=='MCD-CHN'">申请退货</a>
            <a @click="getInvoice(order_info.order_no)" v-if="order_info.invoice_state=='0' && company_no=='SUB-CHN' && (order_info.order_state==5 || order_info.order_state==6)">申请发票</a>
            <a @click="getInvoice(order_info.order_no)" v-if="order_info.invoice_state!='0' && company_no=='SUB-CHN' && (order_info.order_state==5 || order_info.order_state==6)">查看发票</a>
            <a @click="get_order_evaluate(order_info.order_no)" v-if="order_info.order_state==5">评价</a>
            <a v-if="order_info.order_state==2 && order_info.return_state=='1'">退货申请待审核</a>
            <a @click="buy_again(order_info.order_no)" class="red" v-if="order_info.order_state==5 || order_info.order_state==6">再次购买</a>
        </h2>
      </div>
    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

    <b-modal id="all-order-tip" centered hide-footer>
      <template #modal-title @click="$bvModal.hide('all-order-tip')">
        温馨提示
      </template>
      <div class="d-block text-center">
        <h6 style="text-align: left;">{{messageTipMsg}}</h6>
      </div>
      <div class="web-modal-foot">
        <a @click="$bvModal.hide('all-order-tip')" class="no">确认</a>
      </div>
    </b-modal>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl, getCompanyNo} from '@/utils/extend'

export default {
  name: 'order_show',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter
  },
  data () {
    return {
      title: '订单详情',
      web_url: webUrl(),
      company_no: getCompanyNo(),
      pay_win_state: 0,
      header_title: '',
      order_no: '',
      delivery_way: '',
      order_info: {},
      goods_list: [],
      messageTipMsg: ''
    }
  },
  mounted () {
    var params = this.$route.query
    var orderNo = Decrypt(params.v)

    this.load_data(orderNo)
  },
  methods: {
    load_user () {
      var that = this
      ajax({
        url: '/store/user/user_json',
        method: 'post',
        data: {
          uid: getUserId()
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.user_info = ret.data
        }
      })
    },
    getInvoice (orderNo) {
      let that = this
      ajax({
        url: '/store/api/get_invoice?order_no=' + orderNo,
        method: 'post',
        data: {
          uid: getUserId(),
          user_id: getUserId(),
          order_no: orderNo
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          let type = ret.data.type
          if (type === '1') {
            window.open(ret.data.url)
          } else if (type === '2') {
            window.open(ret.data.pdf_url)
          }
        } else {
          that.$bvModal.show('all-order-tip')
          that.messageTipMsg = ret.msg
        }
      })
    },
    get_logistics_info (orderNo) {
      this.$router.push({path: '/order/logistics_info', query: {v: Encrypt(orderNo)}})
    },
    get_sales_return (orderNo) {
      this.$router.push({path: '/order/sales_return', query: {v: Encrypt(orderNo)}})
    },
    get_order_evaluate (orderNo) {
      this.$router.push({path: '/order/order_evaluate', query: {v: Encrypt(orderNo)}})
    },
    buy_again (orderNo) {
      var that = this
      ajax({
        url: '/store/order/buy_again',
        method: 'post',
        data: {
          uid: getUserId(),
          order_no: orderNo
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.$router.push({path: '/cart/order_submit', query: {v: Encrypt(ret.data.cart_id), type_id: 2}})
        }
      })
    },
    load_data (orderNo) {
      var that = this
      ajax({
        url: '/store/order/order_show',
        method: 'post',
        data: {
          uid: getUserId(),
          order_no: orderNo
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.header_title = ret.data.order_info.order_state_name
          that.order_info = ret.data.order_info
          that.goods_list = ret.data.goods_list
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }
input { box-sizing:border-box;outline:none;}
.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-order-state { width:100%; height:50px; margin-top:15px;border-left:3px solid #d81e06;}
    .web-order-state h2 { width:100%; height:50px;  margin:0px;line-height:50px; justify-content:space-between; padding:0px 20px; border:1px solid #dfdfdf;color:#333333;}
    .web-order-state p { width:auto; height:50px; margin:0px; font-weight: bold; padding:0px; line-height:50px; font-size:14px; color:#333333; }
    .web-order-state p b { font-weight: normal; font-size:14px;}
    .web-order-state a { width:auto; height:50px; line-height:50px;  font-size:14px; color:#333333;}
    .web-order-state a:hover { color:#333333;}

.web-order-main { width:100%; height:auto; padding:20px; margin-top:15px; border:1px solid #dfdfdf; flex-wrap:wrap; align-content:flex-start;}
    .web-order-address { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
    .web-order-address h2 { width:100%; height:30px; line-height:30px; font-size:14px; font-weight: bold; margin:0px; padding:0px; color:#333333;}
    .web-order-address ul { width:100%; height:auto; list-style:none; margin:0px; padding:0px; display: flex; flex-flow:row; align-content:flex-start; flex-wrap:wrap;}
    .web-order-address ul li { width:50%; height:30px; margin:0px; padding:0px;}
    .web-order-address ul li p { width:100%; height:30px; margin:0px; padding:0px; line-height:30px; font-size:14px; color:#333333;}
    .web-order-address-line { width:100%; height:5px; margin-top:15px; background-size: auto 100%; background-image:url('../../assets/icon/order_address_line.png'); background-repeat : repeat-x;}

.web-order-info-title { width:100%; height:auto; margin-top:10px; border-bottom: 1px solid #dfdfdf; flex-wrap:wrap; align-content:flex-start;}
    .web-order-info-title h2 { width:100%; height:30px; line-height:30px; font-size:14px; font-weight: bold; margin:0px; padding:0px; color:#333333;}
    .web-order-info-title p { width:100%; height:30px; line-height:30px; font-size:14px; }
    .web-order-info-title p div.custom-radio { cursor: pointer;}
    .web-order-info-title h2 span { font-size:14px; color:#666666; font-weight: normal; margin-left:20px;}

    .web-order-info-integral { width:100%; height: 50px; margin-top:10px;}
        .web-order-info-integral-input { width:200px; height: 30px; border:1px solid #dfdfdf;}
            .web-order-info-integral-input input { width:190px; height:20px; border:0px; margin-top:5px; line-height:20px; font-size:14px; padding:0px 15px;}
        .web-order-info-integral-button { width:100px; height:30px; border:1px solid #d81e06; margin-left:10px;}
            .web-order-info-integral-button p { width:100px; cursor: pointer; height:30px;  text-align: center; line-height: 30px; justify-content:center; font-size:14px; color:#d81e06;}
  .web-cart-list-data { width:100%; height:auto; margin-top:0px; border-left:1px solid #dfdfdf; border-bottom:1px solid #dfdfdf; border-right:1px solid #dfdfdf;}
 .web-cart-list-goods { width:220px; height:auto; line-height:40px; font-size:14px; flex-wrap:wrap; align-content:flex-start; color:#333333;}
  .web-cart-list-goods p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-goods a { width:100%; height:auto; line-height:20px; font-size:14px; color:#aaaaaa;}
  .web-cart-list-goods a:hover { color:#aaaaaa;}
  .web-cart-list-props {width:230px; height:auto; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-props p { width:100%; height:auto; line-height:20px;  padding-top:47px;  padding-left:50px; font-size:14px; color:#333333;}
  .web-cart-list-price {width:130px; height:auto; line-height:80px; font-size:14px; color:#333333;}
  .web-cart-list-price p { width:100%; height:auto; line-height:80px;  padding-left:50px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-quantity { width:130px; height:auto; text-align: center; justify-content:flex-end; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-quantity p { width:136px; height:40px; line-height:40px;  text-align: center; justify-content: center; overflow: hidden; flex-flow:row; margin-top:35px;}
  .web-cart-list-quantity p a { width: 40px; height: 40px; cursor: pointer; background: #efefef; font-size:28px; color:#333333; line-height:34px; text-align: center; justify-content:center;}
  .web-cart-list-quantity p input { width:55px; height:38px; line-height:38px; text-align: center; font-size:14px; color:#333333; border:0px; min-height: 20px;}
  .web-cart-list-sum { width:120px; height:auto; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-sum p { width:100%; height:auto; line-height:20px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-action { width:100px; height:auto; line-height:40px; text-align: center; justify-content:center; font-size:14px; color:#333333;}
  .web-cart-list-action a { width:100%; height:auto; cursor: pointer; text-align: center; justify-content:center; line-height:20px; margin-top:15px; font-size:14px; color:#333333;}
  .web-cart-list-checkbox { width:110px; height:auto; line-height:40px; font-size:14px; color:#333333;}
  .web-cart-list-checkbox img { width:80px; height:80px; cursor: pointer; margin:15px 0px 15px 15px;}

  .web-order-goods-box { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}

.web-order-footer { width:100%; height:auto; flex-wrap:wrap; border:1px solid #dfdfdf; border-top:0px;  align-content:flex-start;}
    .web-order-footer ul { width:100%; height:auto; margin:0px; padding:0px 15px; flex-wrap:wrap; align-content:flex-start;}
    .web-order-footer ul.money {  height:90px; background: #f4f4f4; padding-top:15px; border-top:1px solid #dfdfdf;}
    .web-order-footer ul li { width:100%; height:30px;margin:0px; padding:0px; justify-content:flex-end;}
    .web-order-footer ul li p { width:70px; height:30px;margin:0px; padding:0px; line-height:30px; color:#333333; font-size:14px;}
    .web-order-footer ul li a { min-width:120px; height:30px; line-height:30px; color:#333333; font-size:14px; text-align: right; justify-content:flex-end;}
    .web-order-footer ul li a:hover { color:#333333;}
    .web-order-footer ul li a span { color:#999999; margin-left:5px;}
    .web-order-footer ul li a span.select { color:#E6A23C;}
    .web-order-footer ul li a.red { color:#d81e06; font-size:18px; font-weight: bold;}
    .web-order-footer h2 { width:100%; height:50px; padding-right:15px; margin-top:15px; justify-content:flex-end;}
    .web-order-footer h2 a { width:120px; height:30px; margin-left:15px; cursor: pointer;border: 1px solid #dfdfdf; line-height:30px; border-radius: 4px; text-align: center; justify-content:center; background: #ffffff; font-size:14px; color:#333333;}
    .web-order-footer h2 a:hover { color:#333333;}
    .web-order-footer h2 a.red { color:#ffffff; background: #d81e06;border: 1px solid #d81e06;}
    .web-order-footer h2 a.red:hover { color:#ffffff;}

#textarea { font-size:14px;}

.web-order-goods-list-box { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start; }
  .web-order-goods-list-top { width:100%; height:50px; border:1px solid #dfdfdf;}
    .web-order-goods-list-top ul { width:100%; height:50px; list-style: none; margin:0px; padding:0px;}
    .web-order-goods-list-top ul li { width:100px; height:50px; font-size:14px; line-height:50px; }

</style>



// WEBPACK FOOTER //
// src/pages/order/order_show.vue